$ = require 'jquery'
Auth = require 'db/auth'
{ Emoji } = require 'emoji-mart'
l = require 'lib/localize'
ldclient = require 'lib/ldclient'
ModelCache = require 'db/model-cache'
t = require('views/internal/recup-with-helpers')('reactions')
trackUe = require 'debug/trackUe'
Tooltip = require 'views/lib/tooltip'
React = require 'react'
reactionIconTemplate = require '../templates/reaction_icon'
ReactionTooltip = require 'views/reactions/reaction-tooltip'
View = require 'view'
Util = require 'lib/util'
_ = require 'underscore'

module.exports = class extends React.Component
  displayName: 'ReactionPiles'

  constructor: (props) ->
    super(props)
    @emojiMartEnabled = ldclient.variation('web.emoji_mart', false)

  trackWithData: (verb, dirObj, prepObj, indObj, method) ->
    actionData = JSON.stringify
      actionId: @props.actionId

    trackUe("Reactions", verb, dirObj, prepObj, indObj, method, actionData)


  toggleReaction: (emoji, e) =>
    Util.stop(e)

    if !@props.canReact
      return

    trackFn = (isAdded) =>
      method =
        'by clicking the pile'
      @trackWithData(
        if isAdded then 'adds' else 'removes',
        'reaction',
        emoji.id,
        if isAdded then 'to a comment' else 'from a comment',
        method,
      )

    @props.reactionList.toggleReaction(@props.actionId, emoji, trackFn)

  showReactionTooltip: (emoji, e) =>
    $btn = $(e.currentTarget)
    reaction = emoji.colons

    currentUserReacted = false
    # Get all the reactions for the current hover
    names =
      @props.reactionList.chain()
      .map (model) => model.toJSON({
        makeColons: !model?.get('emoji').colons
      })
      .filter (model) =>
        # once we have @emojiMartEnabled to 100%, we can get
        # rid of this conditional and only have to compare the colon value
        if model?.emoji.colons
          model.emoji.colons == reaction
        else
          model.emoji == reaction.slice(1, -1)
      .omit (reaction) ->
        isCurrentUser = reaction.idMember == Auth.myId()
        if isCurrentUser
          currentUserReacted = true
        isCurrentUser
      .map (reaction) => ModelCache.get('Member', reaction.idMember)?.get 'fullName'
      .compact()
      .value()

    if currentUserReacted
      names = [l('You'), names...]

    tooltipHtml = new ReactionTooltip { names, reaction }

    Tooltip.show(tooltipHtml, $btn, false, Tooltip.STYLE.MENU)

  hideReactionTooltip: ->
    Tooltip.hide()

  mapReactionListToPiles: ->
    @props.reactionList.chain()
      .map (model) ->
        reactionModel = model.toJSON({
          makeColons: !model?.get('emoji').colons
        })
      .groupBy((reaction) ->
        reaction?.emoji.colons or
        # the reactions we get from the server are objects
        # but the ones we add from the view are strings
        if reaction.emoji.shortName then reaction.emoji.shortName else reaction.emoji
      )
      .pairs()
      .map ([emoji, entries]) ->
        reaction: emoji
        count: entries.length
        mine: _.any(entries, ({ idMember }) -> idMember == Auth.myId())
      .value()

  handleEmojiClick: (emoji, e) =>
    @hideReactionTooltip()
    @toggleReaction(emoji, e)
    @props.onEmojiClick && @props.onEmojiClick(emoji, e)

  handleEmojiOver: (emoji, e) =>
    @showReactionTooltip(emoji, e)
    @props.onEmojiOver && @props.onEmojiOver(emoji, e)

  render: t.renderable ->
    {
      reactionList,
      canReact,
      onEmojiClick,
      onEmojiOver,
    } = @props

    reactions = @mapReactionListToPiles()

    t.div '.reaction-piles', { class: t.classify({
      'reaction-piles-empty': !reactions.length,
      'twemoji': @emojiMartEnabled
    }) }, =>
      for { reaction, count, mine } in reactions
        t.div '.reaction-pile-item', { class: t.classify('my-reaction': mine), 'data-reaction': reaction }, =>
          t.addElement React.createElement Emoji, {
            emoji: reaction
            set: "#{if @emojiMartEnabled then 'twitter' else 'apple'}"
            size: 16
            onClick: @handleEmojiClick
            onOver: @handleEmojiOver
            onLeave: @hideReactionTooltip
          }
          t.span '.reaction-pile-count', ->
            t.text count
      if reactions.length
        t.div '.reaction-pile-selector', ->
          t.raw reactionIconTemplate
            disabled: !canReact
            withBorder: true



// WEBPACK FOOTER //
// ./app/scripts/views/reactions/reaction-piles.coffee